module.exports = __webpack_public_path__ + "static/media/mesonry-cat2-lg-4.300e51b5.jpg";